import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@apple/features/auth/utils/require-auth';

export const Route = createFileRoute('/_authed/store-events')({
	beforeLoad: args =>
		requireAuth(args, {
			requirePermission: 'AppleRetail.Security.Features.StoreEventManagement.Read',
		}),
});
